import Vue from "vue";
import axios from "axios";
import { ChunkMedia, Media } from "@/store/media/mediaModel";
import {
  ADD_MEDIA,
  ADD_TO_MEDIA_CHUNK_QUEUE,
  CLEAR_MEDIA,
  CREATE_CHUNK_MEDIA,
  CREATE_MEDIA,
  CREATE_SLIDE_MEDIA, CREATE_TMP_CHUNK_VIDEO, CREATE_TMP_CHUNK_VIDEO_IN_PROGRESS, CREATE_VIDEO_SLIDE_FROM_CHUNK,
  DELETE_MEDIA,
  DOWNLOAD_MEDIA,
  MEDIA_UPDATE_MEDIAID,
  METADATA_MEDIA, PREVIEW_TEXT_2_SPEECH_GENERATE,
  REFRESH_MEDIA,
  REMOVE_MEDIA_FROM_QUEUE,
  SEND_CHUNK_MEDIA,
  SEND_VIRTUAL_MEDIA,
  SET_BLOB_TO_MEDIA,
  SET_MEDIA_LIST,
  SRT_2_SPEECH_GENERATE,
  TEXT_2_SPEECH_GENERATE,
  UPDATE_METADATA,
  VALIDATE_MEDIA,
  VIDEO_2_SLIDE_GENERATE,
  VOICE_OVER_MEDIA
} from "@/store/media/mediaAction";
import {
  ATTACHED_MEDIA_TO_WEET,
  ATTACHED_TIMELINE_TO_WEET,
  AttachedMediaParams,
  AttachedTimeLineParams
} from "@/store/myWeet/myWeetAction";
import { MEDIA_CHUNK_UPLOAD_START, MediaMetadata, MediaUploadChunkParams } from "@/store/upload/uploadAction";
import {
  MediaIDUpdateParams,
  SAVE_TIMELINE_IF_NEED,
  TIMELINE_UNSAVED,
  TIMELINE_UPDATE_MEDIAID
} from "@/store/timeLine/timeLineAction";
import store from "@/store";
import { MEDIA_DOWNLOAD_START, MediaDownloadParams } from "@/store/download/downloadAction";
import { UPDATE_MEDIA_ID_RECORDING_STATE } from "@/store/recordingState/recordStateAction";
import { log } from "@/utils/log";
import queue from "queue";
import Queue from "queue";
import { BACK_ENDPOINT } from "@/store/conf/api";
import { ScreenVirtualBackgroundEnum } from "@/enum/ScreenVirtualBackgroundEnum";
import { TRANSCRIPT_SAVE, UPDATE_MEDIAID_TRANSCRIPT } from "@/store/transcript/transcriptAction";
import { isMediaNeedRefresh, isURL, stringToBase64 } from "@/utils/util";
import { uniqBy } from "lodash";
import { Text2SpeachParams, VoiceOverParams } from "@/store/AIAvatar/aiavatarGenerationModel";
import delay from "delay";
import { Slide } from "@/store/slides2Video/slides2VideoModels";
import { checkValidSSML, generateErrorMessages } from "@/utils/ssmlUtil";
import { SourceVideoType } from "@/enum/SourceVideoEnum";
import { escapeForSSML } from "@/utils/voiceUtil";


export const LIST_OF_QUEUE = {};
export const MEDIA_API = BACK_ENDPOINT + "/media";
export const SCREEN_VB_API = MEDIA_API + "/virtualMedia";

export const AIAVATAR_API = MEDIA_API + "/aiAvatar";
export const SLIDE2VIDEO_API = MEDIA_API + "/slide2Video";
export const SLIDE_HTML_API = MEDIA_API + "/slide";
export const SLIDE_FROM_CHUNK_API = MEDIA_API + "/slideFromChunk";

export const TEXT_TO_SPEECH_API = MEDIA_API + "/text2Speech";
export const SRT_TO_SPEECH_API = MEDIA_API + "/srt2Speech";

// queuing of refreshing media
const REFRESH_MEDIA_QUEUE = new Queue({ concurrency: 2, timeout: 600, autostart: true });
// lock of refreshing media to avoir dupplicate request
const CURRENT_REFRESHING_MEDIA: Media[] = [];

export default {
  state: {
    medias: {},
    processingFileMetadata: null,
    srt2SpeechLoading: false,
    previewText2Speech: false,
    isVideoChunkGenerating: false
  },
  mutations: {
    [CREATE_MEDIA]: (state: any, media: Media) => {
      Vue.set(state.medias, media.mediaID, media);
    },
    [PREVIEW_TEXT_2_SPEECH_GENERATE]: (state: any, value: boolean) => {
      state.previewText2Speech = value;
    },
    [SRT_2_SPEECH_GENERATE]: (state: any, loading: boolean) => {
      state.srt2SpeechLoading = loading;
    },
    [SET_MEDIA_LIST]: (state: any, medias: Media[]) => {
      state.medias = [];
      for (const media of medias) {
        Vue.set(state.medias, media.mediaID, media);
      }
    },
    [SET_BLOB_TO_MEDIA]: (state: any, {
      mediaId,
      blobURL,
      imageURL
    }: { mediaId: string, blobURL: string, imageURL: string }) => {
      let media = state.medias[mediaId];
      if (!media) {
        // so we search the record, maybe it's ask the old ID
        for (const mediaSearch of Object.values(state.medias) as Media[]) {
          if (mediaSearch.recordID === mediaId) {
            media = mediaSearch;
            break;
          }
        }
      }
      if (media) {
        // this method if to allow reactivity on media change
        media.blobURL = blobURL;
        media.imageBlobURL = imageURL;
        Vue.set(state.medias, mediaId, media);
        // Vue.set(media, 'blobURL', blobURL);
        // Vue.set(media, 'imageBlobURL', imageURL);
      }
    },
    [ADD_TO_MEDIA_CHUNK_QUEUE]: (state: any, { chunk, sender }: { chunk: ChunkMedia, sender: any }) => {
      // now we verify the queue
      let queueMedia: Queue = LIST_OF_QUEUE[chunk.mediaID];
      if (queueMedia === undefined) {
        queueMedia = queue({
          concurrency: 1, // A LA QUEUE LEU LEU
          autostart: true
        });
      }
      LIST_OF_QUEUE[chunk.mediaID] = queueMedia;
      // put the senderInTheQueue
      queueMedia.push(sender);
    },
    [REMOVE_MEDIA_FROM_QUEUE]: (state: any, mediaID: string) => {
      const queueMedia: Queue = LIST_OF_QUEUE[mediaID];
      if (queueMedia !== undefined) {
        queueMedia.stop();
        queueMedia.end();
      }
    },
    [MEDIA_UPDATE_MEDIAID]: (state: any, params: MediaIDUpdateParams) => {
      // upadte the mediaID withh the backend mediaID
      // const media = state.medias[params.oldID] as Media;
      // keep the blob URL if there is a blob
      const mediaOld = state.medias[params.oldID];
      let blobURL;
      let imageBlobURL;
      let validate = true;
      if (mediaOld) {
        blobURL = mediaOld.blobURL;
        imageBlobURL = mediaOld.imageBlobURL;
        validate = mediaOld.validate;
      }
      Vue.delete(state.medias, params.oldID);
      const media = params.media;
      media.blobURL = blobURL;
      media.imageBlobURL = imageBlobURL;
      media.recordID = params.oldID;
      media.saved = true;
      media.validate = validate;
      Vue.set(state.medias, media.mediaID, media);
    },

    [VALIDATE_MEDIA]: (state: any, mediaID: string) => {
      const media = state.medias[mediaID];
      if (media) {
        media.validate = true;
        Vue.set(state.medias, media.mediaID, media);
      } else {
        log.warn("media not found:" + mediaID);
      }
    },
    [DELETE_MEDIA]: (state: any, mediaID: string) => {
      Vue.delete(state.medias, mediaID);
    },
    [CLEAR_MEDIA]: (state: any) => {
      state.medias = {};
    },
    [METADATA_MEDIA]: (state: any, params: MediaMetadata) => {
      // remove table
      state.processingFileMetadata = params;
    },
    [CREATE_TMP_CHUNK_VIDEO_IN_PROGRESS]: (state: any, value: boolean) => {
      // remove table
      state.isVideoChunkGenerating = value;
    }

  },
  getters: {
    getMedias: (state: any): Media[] => {
      // bug : https://speacher.speach-qa.com/play/196866b4/blocking-issue-on-recorder-can-t-save-close-the-weet
      // Array converston send multiple time media... it's normaly impossible :-(
      // so filter by uniq mediaID...
      let listOfMedia = Object.values(state.medias);
      listOfMedia = uniqBy(listOfMedia, "mediaID");
      return listOfMedia as Media[];
    },
    isAvatarGenerateInProgress: (state: any): boolean => {
      return state.avatarGenerateInProgress;
    },
    getMetadataProcessingFile: (state: any): MediaMetadata => {
      return state.processingFileMetadata;
    },
    getMediasForMediaId: (state: any) => (mediaId: string): Media => {
      return state.medias[mediaId];
    },
    isAllMediaSavedAndValidate: (state: any): boolean => {
      let saved = true;
      for (const media of Object.values(state.medias)) {
        if (media !== undefined && (!(media as Media).saved || !(media as Media).validate)) {
          saved = false;
          break;
        }
      }
      return saved;
    },
    isPreviewSpeech2Text: (state: any): boolean => {
      return state.previewText2Speech;
    },
    isSrt2SpeechLoading: (state: any): boolean => {
      return state.srt2SpeechLoading;
    },
    isVideoChunkGenerating: (state: any): boolean => {
      return state.isVideoChunkGenerating;
    }
  },
  actions: {
    async [ADD_MEDIA]({
                        commit,
                        dispatch,
                        state,
                        getters
                      }: { commit: any, dispatch: any, state: any, getters: any },
                      media: Media) {
      commit(CREATE_MEDIA, media);
    },
    async [SET_BLOB_TO_MEDIA]({
                                commit,
                                dispatch,
                                state,
                                getters
                              }: { commit: any, dispatch: any, state: any, getters: any },
                              {
                                mediaId,
                                blobURL,
                                imageURL
                              }: { mediaId: string, blobURL: string, imageURL: string }) {
      log.debug("📷 UPDATE BLOB for " + mediaId);
      commit(SET_BLOB_TO_MEDIA, { mediaId, blobURL, imageURL });
    },
    async [CREATE_CHUNK_MEDIA]({
                                 commit,
                                 dispatch,
                                 state,
                                 getters
                               }: { commit: any, dispatch: any, state: any, getters: any },
                               chunk: ChunkMedia) {
      log.debug("👌 Create Chunk " + chunk.mediaID + " part " + chunk.partNumber + " last " + chunk.lastPart);
      // before record we create an ID
      // this id must be provide before the first chunk upload
      const sender = (): Promise<void> => {
        return new Promise((resolve, reject) => {
          dispatch(SEND_CHUNK_MEDIA, chunk).then(() => {
            resolve();
          });
        });
      };
      commit(ADD_TO_MEDIA_CHUNK_QUEUE, { chunk, sender });
    },


    // launche by the Queue

    // 2 - Create the media in front Part (Media ID is temporary)
    // 3 - Upload the Media
    // 4 - Update Media Id with the real media ID
    // 5 - Update the timeLine media ID
    // 6 - Attache the media to the weet
    // 7 - If there is no other synchronisation, save the timeLine
    async [SEND_CHUNK_MEDIA]({
                               commit,
                               dispatch,
                               state,
                               getters
                             }: { commit: any, dispatch: any, state: any, getters: any },
                             chunk: ChunkMedia) {

      const chunkUploadParams = new MediaUploadChunkParams(chunk);

      await dispatch(MEDIA_CHUNK_UPLOAD_START, chunkUploadParams).then(
        async (params: MediaIDUpdateParams) => {
          // if we have an mediaID the mediaA is finish to upload
          // so we can proceed to the update
          if (getters.getEditingWeetID === "" && !chunk.mediaCreatorMode) {
            // so there is a huge problem here
            throw Error("Impossible to upload a chunk file if there is no weet ID");
          }
          if (chunk.lastPart) {
            log.debug("End of media Upload " + chunk.mediaID + " " + new Date().getTime());
            await dispatch(UPDATE_MEDIAID_TRANSCRIPT, params);
            await commit(MEDIA_UPDATE_MEDIAID, params);
            // we update the recorderStateToo
            await dispatch(UPDATE_MEDIA_ID_RECORDING_STATE, params);
            // 5 -  we wait the update of the timeLine
            await dispatch(TIMELINE_UPDATE_MEDIAID, params);


            // TODO externalize that
            // if we the media is not on media creator only,
            // so we attached the media to the timeline of the weet
            if (!chunk.mediaCreatorMode) {

              // 6 - attach Media
              const attachedParams = new AttachedMediaParams(getters.getEditingWeetID, params.media.mediaID);
              await dispatch(ATTACHED_MEDIA_TO_WEET, attachedParams);

              dispatch(TRANSCRIPT_SAVE, {
                mediaID: params.media.mediaID,
                weetID: getters.getEditingWeetID
              });
              // now we launch the update Media
              await dispatch(REFRESH_MEDIA, params.media);
              // we can attached the timeline
              await dispatch(SAVE_TIMELINE_IF_NEED);
              return params.media.mediaID;
            } else {
              dispatch(TRANSCRIPT_SAVE, { mediaID: params.media.mediaID, weetID: chunk.weetID });
            }
          }
        }
      );
    },
    async [VOICE_OVER_MEDIA]({
                               commit,
                               dispatch,
                               state,
                               getters
                             }: { commit: any, dispatch: any, state: any, getters: any },
                             voiceOverParams: VoiceOverParams
    ) {
      if (getters.getEditingWeetID === "") {
        // so there is a huge problem here
        throw Error("Impossible to voiceover a file without weet ID");
      }
      const formData = new FormData();
      formData.append("audio", voiceOverParams.audioToUpload);
      formData.append("mediaID", voiceOverParams.mediaID);
      if (voiceOverParams.transcript?.length) {
        formData.append("transcriptB64", stringToBase64(voiceOverParams.transcript));
      }

      return await axios({
        method: "POST",
        url: MEDIA_API + "/" + getters.getEditingWeetID + "/" + voiceOverParams.mediaID + "/voiceOver",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "Content-Disposition": "form-data; name=media"
        }
      }).then(async (resp) => {
        const newMedia = resp.data as Media;
        const params = new MediaIDUpdateParams(voiceOverParams.mediaID, newMedia);
        if (getters.getEditingWeetID === "") {
          // so there is a huge problem here
          throw Error("Impossible to voiceover a file without weet ID");
        }


        await dispatch(UPDATE_MEDIAID_TRANSCRIPT, params);
        await commit(MEDIA_UPDATE_MEDIAID, params);
        // we update the recorderStateToo
        await dispatch(UPDATE_MEDIA_ID_RECORDING_STATE, params);
        // 5 -  we wait the update of the timeLine
        await dispatch(TIMELINE_UPDATE_MEDIAID, params);

        const attachedParams = new AttachedMediaParams(getters.getEditingWeetID, params.media.mediaID);
        await dispatch(ATTACHED_MEDIA_TO_WEET, attachedParams);

        await dispatch(TIMELINE_UNSAVED);
        // now we launch the update Media
        await dispatch(REFRESH_MEDIA, newMedia);

        // we can attached the timeline
        await dispatch(SAVE_TIMELINE_IF_NEED);
        return newMedia;
      });
    },
    async [PREVIEW_TEXT_2_SPEECH_GENERATE]({ commit, dispatch, state, getters }: {
                                             commit: any,
                                             dispatch: any,
                                             state: any,
                                             getters: any
                                           },
                                           value: boolean) {
      commit(PREVIEW_TEXT_2_SPEECH_GENERATE, value);

    },
    async [TEXT_2_SPEECH_GENERATE]({
                                     commit,
                                     dispatch,
                                     state,
                                     getters
                                   }: { commit: any, dispatch: any, state: any, getters: any },
                                   text2SpeachParams: Text2SpeachParams
    ) {
      const maxTry = 500;
      // Get validation errors from SSML checker
      const ssmlErrors = await checkValidSSML(escapeForSSML(text2SpeachParams.text));
      if (ssmlErrors.length > 0) {
        // Format SSML errors into a readable string message
        const errorMessages = generateErrorMessages(ssmlErrors);
        throw new Error(errorMessages);
      }
      return new Promise(async (resolve, reject) => {
        let currentJobID: string | null = null;
        for (let i = 0; i < maxTry; i++) {
          const response = await axios(
            {
              url: TEXT_TO_SPEECH_API,
              method: "POST",
              data: {
                text: text2SpeachParams.text,
                voice: text2SpeachParams.voice,
                lang: text2SpeachParams.lang,
                jobID: currentJobID
              }
            });
          if (response.status === 200 && response.data.base64?.length > 10) {
            return resolve(response.data.base64);
          } else {
            currentJobID = response.data.jobID;
          }
          await delay(2000);
        }
      });
    },
    async [SRT_2_SPEECH_GENERATE]({
                                    commit,
                                    dispatch,
                                    state,
                                    getters
                                  }: { commit: any, dispatch: any, state: any, getters: any },
                                  text2SpeachParams: Text2SpeachParams
    ) {
      const maxTry = 500;
      log.debug("Launch srt2Speech");
      return new Promise(async (resolve, reject) => {
        let currentJobID: string | null = null;
        for (let i = 0; i < maxTry; i++) {
          const response = await axios(
            {
              url: SRT_TO_SPEECH_API,
              method: "POST",
              data: {
                srtText: text2SpeachParams.text,
                voice: text2SpeachParams.voice,
                lang: text2SpeachParams.lang,
                gender: text2SpeachParams.gender,
                jobID: currentJobID
              }
            });
          if (response.status === 200 && response.data.base64?.length > 10) {
            log.debug("Srt2Speech finish");
            return resolve(response.data.base64);
          } else {
            currentJobID = response.data.jobID;
          }
          await delay(2000);
        }
      });
    },


    async [SEND_VIRTUAL_MEDIA]({
                                 commit,
                                 dispatch,
                                 state,
                                 getters
                               }: { commit: any, dispatch: any, state: any, getters: any },
                               { media, type }: { media: Media, type: ScreenVirtualBackgroundEnum }) {

      if (getters.getEditingWeetID === "") {
        // so there is a huge problem here
        throw Error("Impossible to create virtualMedia if there is no weet ID");
      }
      commit(CREATE_MEDIA, media);

      const response = await axios(
        {
          url: SCREEN_VB_API,
          method: "POST",
          data: {
            screenVirtualBackground: type
          }
        }).then(async (resp) => {
        const refreshMedia = resp.data;
        refreshMedia.saved = true;
        // now we update the mediaID
        const params = new MediaIDUpdateParams(media.mediaID, refreshMedia);

        await commit(MEDIA_UPDATE_MEDIAID, params);
        await dispatch(UPDATE_MEDIA_ID_RECORDING_STATE, params);

        await dispatch(TIMELINE_UPDATE_MEDIAID, params);


        const attachedParams = new AttachedMediaParams(getters.getEditingWeetID, params.media.mediaID);
        await dispatch(ATTACHED_MEDIA_TO_WEET, attachedParams);

        log.debug("Is All Media Saved = " + getters.isAllMediaSavedAndValidate + " and Validate");
        if (getters.isAllMediaSavedAndValidate && getters.timelineNeedToBeSaved) {
          // after the media is really update we start the synchronisation of the timeline
          const attachedTimeLineParams = new AttachedTimeLineParams(
            getters.getEditingWeetID,
            getters.getTimeEvent,
            getters.getOffsetTimeEventUpdate
          );
          store.dispatch(ATTACHED_TIMELINE_TO_WEET, attachedTimeLineParams);
        }
        return refreshMedia;
      }).catch((err) => {
        throw err;
      });

      return response;
    },
    async [DOWNLOAD_MEDIA]({
                             commit,
                             dispatch,
                             state,
                             getters
                           }: { commit: any, dispatch: any, state: any, getters: any },
                           media: Media) {
      const downloadMedia = new MediaDownloadParams(media);
      dispatch(MEDIA_DOWNLOAD_START, downloadMedia).then((blobUrl) => {
        // now we set the media (with blob url)
        media.blobURL = blobUrl;
        commit(CREATE_MEDIA, media);
      });
    },
    async [REFRESH_MEDIA]({
                            commit,
                            dispatch,
                            state,
                            getters
                          }: { commit: any, dispatch: any, state: any, getters: any },
                          media: Media) {

      if (CURRENT_REFRESHING_MEDIA[media.mediaID]) {
        log.warn("Ignoring refreshing media, media is currently refreshing");
        return media;
      }
      log.debug("START REFRESH MEDIA " + media.mediaID);
      return await axios(
        {
          url: MEDIA_API + "/" + media.mediaID,
          method: "GET"
        }).then((resp) => {
        const refreshMedia = resp.data;
        refreshMedia.saved = true;
        refreshMedia.blobURL = media.blobURL;
        refreshMedia.imageBlobURL = media.imageBlobURL;
        commit(CREATE_MEDIA, refreshMedia);
        dispatch(SAVE_TIMELINE_IF_NEED);
        log.debug("END REFRESH MEDIA " + media.mediaID);

        if (isMediaNeedRefresh(refreshMedia)) {
          CURRENT_REFRESHING_MEDIA[refreshMedia.mediaID] = refreshMedia;
          // we limit the number of concurrency request of Refresh Media
          REFRESH_MEDIA_QUEUE.push(
            async () => {
              await delay(3000);
              // delete lock before relaunch process
              delete CURRENT_REFRESHING_MEDIA[refreshMedia.mediaID];
              dispatch(REFRESH_MEDIA, refreshMedia);
            }
          );
        } else {
          delete CURRENT_REFRESHING_MEDIA[refreshMedia.mediaID];
        }
        return refreshMedia;
      }).catch((err) => {
        throw err;
      });
    },
    [CLEAR_MEDIA]({ commit, dispatch, state }: { commit: any, dispatch: any, state: any }) {
      commit(CLEAR_MEDIA);
    },
    async [VALIDATE_MEDIA]({
                             commit,
                             dispatch,
                             state,
                             getters
                           }: { commit: any, dispatch: any, state: any, getters: any },
                           mediaID: string) {
      if (mediaID) {
        commit(VALIDATE_MEDIA, mediaID);
        if (getters.isAllMediaSavedAndValidate && getters.timelineNeedToBeSaved) {
          // after the media is really update we start the synchronisation of the timeline
          const attachedTimeLineParams = new AttachedTimeLineParams(
            getters.getEditingWeetID,
            getters.getTimeEvent,
            getters.getOffsetTimeEventUpdate
          );
          log.debug("attached timeline after validation");
          store.dispatch(ATTACHED_TIMELINE_TO_WEET, attachedTimeLineParams);
        }
      }
    },
    [DELETE_MEDIA]({ commit, dispatch, state }: { commit: any, dispatch: any, state: any }, mediaID: string) {
      commit(DELETE_MEDIA, mediaID);
    },
    [REMOVE_MEDIA_FROM_QUEUE]({
                                commit,
                                dispatch,
                                state
                              }: { commit: any, dispatch: any, state: any }, mediaID: string) {
      commit(REMOVE_MEDIA_FROM_QUEUE, mediaID);
    },
    async [METADATA_MEDIA]({
                             commit,
                             dispatch,
                             state,
                             getters
                           }: { commit: any, dispatch: any, state: any, getters: any },
                           mediaID: string) {
      if (mediaID) {
        return await axios(
          {
            url: MEDIA_API + "/metadata/" + mediaID,
            method: "GET"
          }).then((resp) => {
          commit(METADATA_MEDIA, resp.data);
          return resp.data;
        });
      }
    },
    async [UPDATE_METADATA]({
                              commit,
                              dispatch,
                              state,
                              getters
                            }: { commit: any, dispatch: any, state: any, getters: any },
                            metadata: MediaMetadata) {
      commit(METADATA_MEDIA, metadata);
    },

    // Convert a Slide in a video Media
    async [VIDEO_2_SLIDE_GENERATE]({
                                     commit,
                                     dispatch,
                                     state,
                                     getters
                                   }: { commit: any, dispatch: any, state: any, getters: any },
                                   { mediaSlide, b64, seconds }: { mediaSlide: Media, b64: string, seconds: number }) {

      if (getters.getEditingWeetID === "") {
        // so there is a huge problem here
        throw Error("Impossible to create aiavatar if there is no weet ID");
      }
      commit(CREATE_MEDIA, mediaSlide);
      const response = await axios(
        {
          url: SLIDE2VIDEO_API,
          method: "POST",
          data: { b64, seconds }
        }).then(async (resp) => {
        const refreshMedia = resp.data;
        refreshMedia.saved = true;
        // now we update the mediaID
        const params = new MediaIDUpdateParams(mediaSlide.mediaID, refreshMedia);
        await commit(MEDIA_UPDATE_MEDIAID, params);
        await dispatch(UPDATE_MEDIA_ID_RECORDING_STATE, params);

        await dispatch(TIMELINE_UPDATE_MEDIAID, params);


        const attachedParams = new AttachedMediaParams(getters.getEditingWeetID, params.media.mediaID);
        await dispatch(ATTACHED_MEDIA_TO_WEET, attachedParams);
        log.debug("Is All Media Saved = " + getters.isAllMediaSavedAndValidate + " and Validate");
        if (getters.isAllMediaSavedAndValidate && getters.timelineNeedToBeSaved) {
          // after the media is really update we start the synchronisation of the timeline
          const attachedTimeLineParams = new AttachedTimeLineParams(
            getters.getEditingWeetID,
            getters.getTimeEvent,
            getters.getOffsetTimeEventUpdate
          );
          store.dispatch(ATTACHED_TIMELINE_TO_WEET, attachedTimeLineParams);
        }
        return refreshMedia;
      }).catch((err) => {
        throw err;
      });
      return response;
    },
    // Create a video base on temporary ID file system and times
    async [CREATE_TMP_CHUNK_VIDEO]({
                                     commit,
                                     dispatch,
                                     state,
                                     getters
                                   }: { commit: any, dispatch: any, state: any, getters: any },
                                   { fileID, startSeconds, endSeconds, progressListener }: {
                                     fileID: string,
                                     startSeconds: string,
                                     endSeconds: number,
                                     progressListener: (progress: number) => void
                                   }) {

      commit(CREATE_TMP_CHUNK_VIDEO_IN_PROGRESS, true);
      const response = await axios(
        {
          url: MEDIA_API + "/createTmpChunkVideo",
          method: "POST",
          data: { fileID, startSeconds, endSeconds }
        }).then(async (resp) => {
        const jobID = resp.data.jobID;
        log.debug("jobID for createTmpChunkVideo " + jobID);
        let time = 0;
        const timeout = 5 * 60 * 1000;
        const intervalTime = 3500;
        while (time < timeout) {
          await delay(intervalTime);
          time += intervalTime;
          const resp = await axios(
            {
              url: MEDIA_API + "/createTmpChunkVideo/" + jobID,
              method: "GET"
            });

          // Process finished because we have an url
          if (resp.data.url) {
            progressListener(100);
            commit(CREATE_TMP_CHUNK_VIDEO_IN_PROGRESS, false);

            return resp.data.url;
          }
          progressListener(resp.data.progress);
        }
        throw Error("Timeout for createTmpChunkVideo");
      }).catch((err) => {
        commit(CREATE_TMP_CHUNK_VIDEO_IN_PROGRESS, false);
        throw err;
      });
      return response;
    },


    // Create a SLIDE HTML Media
    async [CREATE_SLIDE_MEDIA]({
                                 commit,
                                 dispatch,
                                 state,
                                 getters
                               }: { commit: any, dispatch: any, state: any, getters: any },
                               { media, slide }: { media: Media, slide: Slide }
    ) {
      if (getters.getEditingWeetID === "") {
        // so there is a huge problem here
        throw Error("Impossible to create slide html if there is no weet ID");
      }
      if (!media) {
        throw Error("Impossible to create slide html without media");
      }
      commit(CREATE_MEDIA, media);
      const response = await axios(
        {
          url: SLIDE_HTML_API,
          method: "POST",
          data: {
            slideTemplate: slide.slideTemplate,
            title: slide.slideTitle,
            description: slide.slideDescription,
            exportStaticB64: slide.exportStaticB64,
            slideB64: slide.originalDocumentB64,
            videoUrl:slide.slideVideoUrl,
            theme: slide.slideTheme || store.getters.getFavSlideTheme || store.getters.getThemeColor,
            transcriptB64: stringToBase64(slide.script),
            scriptSlideLayout: slide.layout,
            isHtml: media.type === SourceVideoType.SLIDE_HTML,
            promptIllustrationGeneration: slide.promptIllustrationGeneration,
            imageB64: slide.slideImageB64,
            fileID: slide.fileID,
            videoTimestampStart: slide.videoTimestampStart,
            videoTimestampEnd: slide.videoTimestampEnd,

          }
        }
      ).then(async (resp) => {
        const refreshMedia = resp.data;
        refreshMedia.saved = true;
        // now we update the mediaID
        const params = new MediaIDUpdateParams(media.mediaID, refreshMedia);
        await commit(MEDIA_UPDATE_MEDIAID, params);
        await dispatch(UPDATE_MEDIA_ID_RECORDING_STATE, params);

        await dispatch(TIMELINE_UPDATE_MEDIAID, params);
        const attachedParams = new AttachedMediaParams(getters.getEditingWeetID, params.media.mediaID);
        await dispatch(ATTACHED_MEDIA_TO_WEET, attachedParams);
        log.debug("Is All Media Saved = " + getters.isAllMediaSavedAndValidate + " and Validate");
        if (getters.isAllMediaSavedAndValidate && getters.timelineNeedToBeSaved) {
          // after the media is really update we start the synchronisation of the timeline
          const attachedTimeLineParams = new AttachedTimeLineParams(
            getters.getEditingWeetID,
            getters.getTimeEvent,
            getters.getOffsetTimeEventUpdate
          );
          store.dispatch(ATTACHED_TIMELINE_TO_WEET, attachedTimeLineParams);
        }
        return refreshMedia;
      }).catch((err) => {
        throw err;
      });
      return response;
    },
    async [CREATE_VIDEO_SLIDE_FROM_CHUNK]({
                                            commit,
                                            dispatch,
                                            state,
                                            getters
                                          }: { commit: any, dispatch: any, state: any, getters: any },
                                          { media, slide,minDuration }: { media: Media, slide: Slide,minDuration:number }
    ) {

      // CONTENT
      const response = await axios(
        {
          url: SLIDE_FROM_CHUNK_API,
          method: "POST",
          data: {
            slideTemplate: slide.slideTemplate,
            title: slide.slideTitle,
            description: slide.slideDescription,
            exportStaticB64: slide.exportStaticB64,
            slideB64: slide.originalDocumentB64,
            theme: slide.slideTheme || store.getters.getFavSlideTheme || store.getters.getThemeColor,
            transcriptB64: stringToBase64(slide.script),
            scriptSlideLayout: slide.layout,
            isHtml: media.type === SourceVideoType.SLIDE_HTML,
            promptIllustrationGeneration: slide.promptIllustrationGeneration,
            imageB64: slide.slideImageB64,
            fileID: slide.fileID,
            videoTimestampStart: slide.videoTimestampStart,
            videoTimestampEnd: slide.videoTimestampEnd,
            minDuration:minDuration
          }
        }).then(async (resp) => {
        const refreshMedia = resp.data;
        refreshMedia.saved = true;
        // now we update the mediaID
        const params = new MediaIDUpdateParams(media.mediaID, refreshMedia);
        await commit(MEDIA_UPDATE_MEDIAID, params);
        await dispatch(UPDATE_MEDIA_ID_RECORDING_STATE, params);

        await dispatch(TIMELINE_UPDATE_MEDIAID, params);
        const attachedParams = new AttachedMediaParams(getters.getEditingWeetID, refreshMedia.mediaID);
        await dispatch(ATTACHED_MEDIA_TO_WEET, attachedParams);

        if (getters.isAllMediaSavedAndValidate && getters.timelineNeedToBeSaved) {
          // after the media is really update we start the synchronisation of the timeline
          const attachedTimeLineParams = new AttachedTimeLineParams(
            getters.getEditingWeetID,
            getters.getTimeEvent,
            getters.getOffsetTimeEventUpdate
          );
          store.dispatch(ATTACHED_TIMELINE_TO_WEET, attachedTimeLineParams);
        }

        return refreshMedia;
      });
      return response;
    }
  }
};
